import React from 'react'
import { CircularProgress } from '@mui/material'
import styled from 'styled-components'

import { theme } from 'utils/theme'

interface LoadingCircularProps {
  text?: string
  color?: string
  withoutPadding?: boolean
}

export const LoadingCircular = ({
  text = '',
  color = theme.colors.primary,
  withoutPadding
}: LoadingCircularProps) => {
  return (
    <LoadingWrapper $withoutPadding={withoutPadding}>
      <Text $withoutPadding={withoutPadding}>{text}</Text>
      <CircularProgress style={{ color }} />
    </LoadingWrapper>
  )
}

const Text = styled.div<{ $withoutPadding?: boolean }>`
  padding-top: ${({ $withoutPadding }) => ($withoutPadding ? '0' : '100px')};
  display: flex;
  justify-content: center;
`
const LoadingWrapper = styled.div<{ $withoutPadding?: boolean }>`
  padding-top: ${({ $withoutPadding }) => ($withoutPadding ? '0' : '100px')};
  display: flex;
  justify-content: center;
`
